import { render, staticRenderFns } from "./ResultAddons.vue?vue&type=template&id=59c79c45&scoped=true&"
import script from "./ResultAddons.vue?vue&type=script&lang=js&"
export * from "./ResultAddons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c79c45",
  null
  
)

export default component.exports